module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_5.fffb8e38.png";